export interface Store {
    [key: string]: any
};
